/* Structural layout only — colors come from Astryx design tokens (resolved
   inside a <Theme> scope).

   The card fills the height its column gives it (so it ends level with a table
   beside it), and its rows spread through whatever height that leaves. Each
   step of the chain — card, body, list — has to carry the flex column, or the
   list stops at its content height and the rows bunch at the top. */
.card,
.body,
.list {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.list {
  justify-content: space-between;
}
